elabs.NotificationOverlayService = class {
  constructor() {
    const template = document.getElementById('el-notification-overlays-template');
    if (!template) {
      return;
    }

    const fragment = template.content
      ? template.content.cloneNode(true)
      : document.createRange().createContextualFragment(template.innerHTML);
    this.overlays = Array.from(fragment.querySelectorAll('.el-notification-overlay'));

    if (this.overlays.length === 0) {
      return;
    }

    this.currentOverlayIndex = 0;

    const now = Date.now();
    this.overlays = this.overlays.filter((overlay) => {
      const notificationId = overlay.id;
      if (!notificationId) {
        return true;
      }
      const closedUntil = localStorage.getItem(`el-notification-closed-until-${notificationId}`);
      if (!closedUntil) {
        return true;
      }
      return now > Number(closedUntil);
    });

    setTimeout(() => {
      this.showNextOverlay();
    }, 1000);
  }

  showNextOverlay = () => {
    if (this.currentOverlayIndex < this.overlays.length) {
      const overlay = this.overlays[this.currentOverlayIndex];
      this.currentOverlayIndex++;

      document.body.appendChild(overlay);

      const closeButton = overlay.querySelector('button.el-notification-overlay__close-button');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.closeOverlay(overlay);
        });
      }

      // force a reflow to ensure the transition works
      void document.body.offsetWidth;

      requestAnimationFrame(() => {
        document.body.classList.add('el-notification-overlay-visible');
      });
    }
  };

  closeOverlay = (overlay) => {
    const notificationId = overlay.id;
    if (notificationId) {
      // Set a timestamp 2 days from now
      const twoDaysMs = 2 * 24 * 60 * 60 * 1000;
      // const twoDaysMs = 10 * 1000; // For testing, 10 seconds
      const closedUntil = Date.now() + twoDaysMs;
      localStorage.setItem(`el-notification-closed-until-${notificationId}`, closedUntil.toString());
    }
    document.body.classList.remove('el-notification-overlay-visible');
    setTimeout(() => {
      overlay.remove();
      setTimeout(() => this.showNextOverlay(), 500); // Show next overlay after 0.5 seconds
    }, 800); // Match the CSS transition duration
  };

  wireEvents = () => {};
};

elabs.onJavascriptReady(() => {
  void new elabs.NotificationOverlayService();
});
